import {
  dashboardRoute,
  usersRoute,
  rolesRoute,
  pushNotificationRoute,
  userGroupsRoute,
  clientRoute,
  createUserRoute,
  modifyRolesRoute,
  createCenterRoute,
  editCenterRoute,
  deleteCenterRoute,
  // Fixafib Routes
  patientsRoute,
  patientDetailRoute,
  createPatientRoute,
  tasksRoute,
  reportsRoute,
  caseDaysRoute,
  registryRoute,
  centersRoute,
  contactsRoute,
  // Super Admin Routes
  insurancesRoute,
  devicesRoute,
  indicationsRoute,
  specialtiesRoute,
  medicationsRoute,
  medicationFrequenciesRoute,
  medicationHoldTimingsRoute,
  centerLocationsRoute,
  complicationsRoute,
  messagesRoute,
  inboxRoute,
  messageTemplatesRoute,
  communicationMessageTemplatesRoute,
  communicationEmailTemplatesRoute,
  contactDropdownFiltersRoute,
  callsRoute,
  subjectAccessRequestsManagementRoute,
  sarRequestsRoute,
} from "../../../routes/reactRoutes";
import { communicationModesRoute } from "../../../routes/reactRoutes";

export const routeKeys = {
  dashboard: [dashboardRoute],
  userGroups: [userGroupsRoute],
  pushNotification: [pushNotificationRoute],
  clients: [clientRoute],
  // Fixafib Routes
  patients: [patientsRoute, patientDetailRoute, createPatientRoute],
  tasks: [tasksRoute],
  reports: [reportsRoute],
  "case-days": [caseDaysRoute],
  registry: [registryRoute],
  contacts: [contactsRoute],
  centerLocations: [centerLocationsRoute],
  sarRequests: [sarRequestsRoute],
  management: [usersRoute, rolesRoute, centersRoute, insurancesRoute, devicesRoute, indicationsRoute, specialtiesRoute, medicationsRoute, medicationFrequenciesRoute, medicationHoldTimingsRoute, complicationsRoute, messageTemplatesRoute, subjectAccessRequestsManagementRoute],
  userPermissions: [usersRoute, createUserRoute],
  rolePermissions: [rolesRoute, modifyRolesRoute],
  centerPermissions: [centersRoute, createCenterRoute, editCenterRoute, deleteCenterRoute],
  insurancesPermissions: [insurancesRoute],
  devicesPermissions: [devicesRoute],
  indicationsPermissions: [indicationsRoute],
  specialtiesPermissions: [specialtiesRoute],
  medicationsPermissions: [medicationsRoute],
  medicationFrequenciesPermissions: [medicationFrequenciesRoute],
  medicationHoldTimingsPermissions: [medicationHoldTimingsRoute],
  complicationsPermissions: [complicationsRoute],
  subjectAccessRequestsPermissions: [subjectAccessRequestsManagementRoute],
  messageTemplatesPermissions: [messageTemplatesRoute],
  contactDropdownFiltersPermissions: [contactDropdownFiltersRoute],
  messages: [messagesRoute],
  inbox: [inboxRoute],
  communication: [messagesRoute, communicationMessageTemplatesRoute, communicationEmailTemplatesRoute, callsRoute, communicationModesRoute],
  communicationMessages: [messagesRoute],
  communicationMessageTemplates: [communicationMessageTemplatesRoute],
  communicationEmailTemplates: [communicationEmailTemplatesRoute],
  communicationCalls: [callsRoute],
  communicationModes: [communicationModesRoute],
};
